import { FC } from "react";
import ButtonPrimary from "shared/Button/ButtonPrimary";
import { ExclamationTriangleIcon } from "@heroicons/react/24/outline";

interface ErrorDisplayProps {
  onExploreLocations: () => void;
}

const ErrorDisplay: FC<ErrorDisplayProps> = ({ onExploreLocations }) => {
  return (
    <div className="min-h-[60vh] flex items-center justify-center p-6">
      <div className="max-w-md w-full text-center space-y-8">
        {/* Error Icon */}
        <div className="mx-auto w-24 h-24 bg-gradient-to-br from-red-100 to-orange-100 dark:from-red-900/20 dark:to-orange-900/20 rounded-full flex items-center justify-center">
          <ExclamationTriangleIcon className="w-12 h-12 text-red-500 dark:text-red-400" />
        </div>

        {/* Error Message */}
        <div className="space-y-4">
          <h2 className="text-3xl font-bold text-gray-900 dark:text-white">Oups ! Une erreur s'est produite</h2>
          <p className="text-lg text-gray-600 dark:text-gray-400 leading-relaxed">
            Nous n'avons pas pu trouver de réservation avec cette référence. Le lien pourrait être invalide ou
            expiré.
          </p>
        </div>

        {/* Suggestions */}
        <div className="bg-gradient-to-r from-blue-50 to-indigo-50 dark:from-blue-900/20 dark:to-indigo-900/20 rounded-xl p-6 border border-blue-100 dark:border-blue-800/50">
          <h4 className="font-semibold text-blue-900 dark:text-blue-100 mb-3">Que pouvez-vous faire ?</h4>
          <ul className="text-sm text-blue-700 dark:text-blue-300 space-y-2 text-left">
            <li className="flex items-start gap-2">
              <span className="w-1.5 h-1.5 bg-blue-500 rounded-full mt-2 flex-shrink-0"></span>
              Vérifiez que le lien de réservation est correct
            </li>
            <li className="flex items-start gap-2">
              <span className="w-1.5 h-1.5 bg-blue-500 rounded-full mt-2 flex-shrink-0"></span>
              Contactez-nous si le problème persiste
            </li>
            <li className="flex items-start gap-2">
              <span className="w-1.5 h-1.5 bg-blue-500 rounded-full mt-2 flex-shrink-0"></span>
              Explorez nos autres espaces disponibles
            </li>
          </ul>
        </div>

        {/* Action Button */}
        <ButtonPrimary
          onClick={onExploreLocations}
          className="w-full bg-gradient-to-r from-blue-600 to-blue-700 hover:from-blue-700 hover:to-blue-800 shadow-lg hover:shadow-xl transition-all duration-300 transform hover:-translate-y-0.5"
        >
          <span className="flex items-center justify-center gap-2">
            Explorer d'autres espaces
            <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M9 5l7 7-7 7" />
            </svg>
          </span>
        </ButtonPrimary>
      </div>
    </div>
  );
};

export default ErrorDisplay;
